import CardCredentialOtpScreen from 'features/cardManagement/screens/cardCredentialChallenge/CardCredentialOtpScreen/CardCredentialOtpScreen';
import React from 'react';

export default function OnboardingP2PCardCredentialOtpPage() {
  return <CardCredentialOtpScreen returnPath="/onboarding/p2p/debit" />;
}
